/**
 * Analytics Constants
 *
 * Shared definitions for consistent analytics across frontend and backend.
 */
/**
 * Active User Definition
 *
 * A user qualifies as "active" in a given period if they performed
 * any of the qualifying actions during that period.
 *
 * @example
 * // Display in UI
 * `${engagementRate}% engagement. ${ACTIVE_USER_DEFINITION.description}`
 *
 * // Result: "25.5% engagement. Active = sent transaction, claimed, or redeemed in period"
 */
export const ACTIVE_USER_DEFINITION = {
    /** Actions that qualify a user as "active" */
    qualifyingActions: ['TRANSACTION_SEND', 'CLAIM_COMPLETED', 'REDEMPTION_COMPLETED'],
    /** Short description for UI display */
    description: 'Active = sent transaction, claimed, or redeemed in period',
    /** Detailed explanation for tooltips/documentation */
    details: {
        TRANSACTION_SEND: 'User initiated a transaction (spending, transferring, or purchasing)',
        CLAIM_COMPLETED: 'User successfully claimed a campaign reward',
        REDEMPTION_COMPLETED: 'User successfully redeemed an offer',
    },
    /** What does NOT count as active */
    excluded: [
        'Receiving tokens (passive)',
        'Failed or pending claims/redemptions',
        'System-generated transactions (REDEMPTION_RECEIVE)',
    ],
};
/**
 * Engagement rate formula
 * engagementRate = (activeUsers / totalUsers) × 100
 */
export const ENGAGEMENT_RATE_FORMULA = 'activeUsers / totalUsers × 100';
/**
 * Transaction statuses that count for analytics
 */
export const ANALYTICS_VALID_TRANSACTION_STATUSES = ['SUCCEEDED', 'BROADCASTED'];
/**
 * Process statuses that count for analytics (claims, redemptions)
 */
export const ANALYTICS_VALID_PROCESS_STATUS = 'COMPLETED';
//# sourceMappingURL=analytics.constants.js.map